var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{staticClass:"text-center",attrs:{"show-total":"","show-sizer":"","show-elevator":"","total":_vm.total,"current":_vm.page,"page-size":_vm.limit},on:{"on-change":_vm.changePage,"on-page-size-change":_vm.changeLimit}})
}
var staticRenderFns = []

export { render, staticRenderFns }